module.exports = __webpack_public_path__ + "static/media/Europeana.6c22ec88.mp4";